var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form tab-content scroll-fire-fox",
      attrs: { id: "typification-tab" }
    },
    [
      !_vm.disabled
        ? _c("typification-form", {
            attrs: { "object-data": _vm.objectData },
            on: { addTypification: _vm.addTypification }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("typification-table", {
        attrs: { entries: _vm.entries, disabled: _vm.disabled },
        on: {
          "update-item": function($event) {
            return _vm.updateItem($event.index, $event.item)
          },
          delete: _vm.deleteItem
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0088530c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0088530c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Typification/BuildingTypification.vue
// module id = null
// module chunks = 